$(function () {
    // Homepage Slideshow Module
    if ($('#shopify-section-slideshow').length > 0) {
        if (document.documentElement.clientWidth <= 414) {
            $('#slickSlide00 .slideshow__image').css({
                backgroundPosition: 'left'
            });

            $('.slideshow-wrapper').css({
                background: '#fff7f3'
            });
        }

        // Homepage Slideshow Module Live Stylist link
        if ($('.open-chat-widget').length > 0) {
            // Open chat widget on click
            $('a.slideshow__btn.open-chat-widget').on('click', function () {
                $('.zsiq_float').click();
            });
        }
    }

    // Homepage Module Live Stylist link
    if ($('.flexlinks').length > 0) {
        // Open chat widget on click
        $('.flexlinks .linkitems .rich-text__text--medium p a').on('click', function () {
            if ($(this).attr('href') === '#') {
                $('.zsiq_float').click();
            }
        });
    }
});